/* eslint-disable */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {purchaseProposalRequestCreate} from '../../../redux/slices/purchase.slice'
import {proposalCompanyLookup} from '../../../redux/slices/lookup.slice'
import {Select, Datepicker} from '../..'

const PurchaceProposalRequestModal = ({onOpen, onClose, error, id}) => {
  const [show, setShow] = useState(onOpen)
  const intl = useIntl()
  const {proposalCompanyLookupList} = useSelector((state) => state.lookup)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(proposalCompanyLookup())
  }, [])

  useEffect(() => {
    setShow(onOpen)
  }, [onOpen])

  const handleClose = () => {
    setShow(false)
    onClose && onClose()
  }

  useEffect(() => {
    if (error && show) {
      setShow(false)
    }
  }, [error])

  const validSchema = Yup.object().shape({
    Description: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    ProposalCompanyId: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
    latestDateProposal: Yup.string().required(intl.formatMessage({id: 'REQUIRED.GENERAL'})),
  })

  const [formValues] = useState({
    PurchaseRequestId: id,
    Description: '',
    ProposalCompanyId: '',
    latestDateProposal: new Date(),
  })

  const formik = useFormik({
    initialValues: formValues,
    validationSchema: validSchema,
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true)
      dispatch(purchaseProposalRequestCreate(values))
      setShow(false)
      onClose && onClose()
      resetForm()
    },
  })

  return (
    <>
      <Modal
        className='modal-sticky modal-sticky-lg modal-sticky-bottom-right'
        id='kt_inbox_compose'
        role='dialog'
        data-backdrop='false'
        aria-hidden='true'
        tabIndex='-1'
        show={show}
        animation={false}
        aria-labelledby='contained-modal-title-vcenter'
        centered
        onHide={handleClose}
        size='lg'
      >
        <div className='modal-content'>
          <form className='form position-relative' onSubmit={formik.handleSubmit} noValidate>
            <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
              <h5 className='fw-bold m-0'>
                {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS'})}
              </h5>
              <div className='d-flex ms-2'>
                <div
                  className='btn btn-icon btn-sm btn-light-primary ms-2'
                  data-bs-dismiss='modal'
                  onClick={handleClose}
                >
                  <KTSVG className='svg-icon-1' path='/images/icons/duotune/arrows/arr061.svg' />
                </div>
              </div>
            </div>

            <div className='d-block py-5 ps-8 pe-5'>
              <div className='row mb-6'>
                <label className='col-lg-4 required fw-bold fs-6 mb-2'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.DESCRIPTION'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <textarea
                    className='form-control form-control-solid mb-3 mb-lg-0'
                    required
                    disabled={formik.isSubmitting}
                    {...formik.getFieldProps('Description')}
                  />
                  {formik.touched.Description && formik.errors.Description && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.Description}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2 required'>
                  {intl.formatMessage({id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.COMPANYNAME'})}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <Select
                    data={proposalCompanyLookupList}
                    {...formik.getFieldProps('ProposalCompanyId')}
                    onChange={(item) =>
                      formik.setFieldValue('ProposalCompanyId', Number(item?.value))
                    }
                    menuPortalTarget={null}
                  />
                  {formik.touched.ProposalCompanyId && formik.errors.ProposalCompanyId && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.ProposalCompanyId}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className='row mb-6'>
                <label className='col-lg-4 fw-bold fs-6 mb-2 required'>
                  {intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.LATESTDATEPROPOSAL',
                  })}
                </label>
                <div className='col-lg-8 fv-row fv-plugins-icon-container'>
                  <Datepicker
                    {...formik.getFieldProps('latestDateProposal')}
                    onChange={([date]) => formik.setFieldValue('latestDateProposal', date)}
                  />
                </div>
              </div>
            </div>

            <div className='d-flex align-items-center justify-content-center py-5 ps-8 pe-5 border-top'>
              <div className='d-flex align-items-center me-3'>
                <button className='btn btn-light me-3' onClick={handleClose}>
                  {intl.formatMessage({id: 'BUTTON.CLOSE'})}
                </button>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >
                  {intl.formatMessage({
                    id: 'REQUEST.GET.PURCHASEPROPOSALREQUESTITEMS.BUTTON.SUBMIT',
                  })}
                </button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  )
}

PurchaceProposalRequestModal.propTypes = {
  onOpen: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
}

PurchaceProposalRequestModal.defaultProps = {
  onOpen: false,
}

export {PurchaceProposalRequestModal}
